export default {
  NO_PAYMENTS: 'Aucun payment',
  REMAINING: 'Montant restant',
  PAID: 'Payée',
}
